import type {ReactNode} from 'react';
import {createContext, useContext} from 'react';
import type {TenantThemeConfig} from '@common-web/types/tenantTheme';

const EMPTY_THEME: TenantThemeConfig = {};
const TenantThemeContext = createContext<TenantThemeConfig>(EMPTY_THEME);

export function TenantThemeProvider({
  children,
  theme,
}: {
  children: ReactNode;
  theme?: TenantThemeConfig;
}) {
  return (
    <TenantThemeContext.Provider value={theme ?? EMPTY_THEME}>
      {children}
    </TenantThemeContext.Provider>
  );
}

export function useTenantTheme(): TenantThemeConfig {
  return useContext(TenantThemeContext);
}
